import fromQueryString from '../fromQueryString';
import getModuleName from '../getModuleName';

/**
 * Parses the URL hash and returns the path and query
 *
 * @param {String} hash hash to parse, if null, window.location.hash is used
 * @return {Object} parsed url hash object
 */
export default function parseURLHash(hash = null) {
    if (hash === null) {
        hash = window.location.hash;
    }

    const [path, query] = hash.split('?');
    const parsed = {path};
    const [view, module, record] = parsed.path.replace('#', '').split('/');

    if (view) parsed.view = decodeURIComponent(view);
    if (module) parsed.module = getModuleName(decodeURIComponent(module));
    if (record) parsed.record = decodeURIComponent(record);
    if (query) parsed.query = fromQueryString(query);

    return parsed;
}
